import productImg from "../../../assets/img/product-6-and-bonus-white.png";
import productImgWebp from "../../../assets/img/product-6-and-bonus-white.webp";
import cardsImg from "../../../assets/img/cards.png";
import cardsImgWebp from "../../../assets/img/cards.webp";

const ActNow = () => (
    <section id="act-now">
        <div className="container-fluid gg-bg-solid-blue text-white">
            <div className="row justify-content-center align-content-center text-center py-3 gg-bg-solid-yellow-light text-black">
                <div className="col-xxl-5 col-xl-7 col-lg-8 col-11">
                    <h1 className="fw-bold">But You Must Act Now.</h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center pt-5">
                <div className="col-md-8 col-11 text-center">
                    <h5 className="fw-light mb-2">This exclusive 6-bottle upgrade is only available on this page.</h5>
                    <h5 className="fw-light mb-2">The moment you leave, it’s gone.</h5>
                    <h5 className="fw-light mb-5">This exclusive 6-bottle upgrade is only available on this page.</h5>
                    <h4 className="mb-0">✔ FREE Shipping (US only)</h4>
                    <h4 className="mb-5">✔ No auto-billing. No sneaky charges. Ever.</h4>
                </div>
            </div>
            <div className="row align-items-center justify-content-center text-center">
                <div className="col-12">
                    <picture>
                        <source srcSet={productImgWebp} type="image/webp" />
                        <img className="img-fluid" src={productImg} loading="lazy" />
                    </picture>
                </div>
            </div>
            <div className="row justify-content-center text-center my-4">
                <div className="col-xxl-3 col-lg-4 col-md-6 col-sm-7 col-10 ">
                    <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu6u&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-decoration-none btn gg-button-buy-yellow gg-buy-card-button gg-bigger-button fw-bold text-uppercase gtm-buy-btn" data-gtm-label="GlucoGen Upsell 6 - Act Now - Yes Button" data-gtm-product="glu6u" data-gtm-price="216">YES, I want to finish what I started</a>
                </div>
            </div>
            <div className="row justify-content-center text-center pb-4">
                <div className="col-xxl-6 col-xl-7 col-lg-8 col-sm-10">
                    <div className="mb-5">
                        <a href="https://buygoods.com/secure/upsell/?account_id=11273&product_codename=glu6u&redirect=aHR0cHM6Ly9nbHVjb2dlbjE3LmNvbS9iZy91ZC9vcHRpdmlzdGEtdQ==" className="text-white gtm-buy-btn" data-gtm-label="GlucoGen Upsell 6 - Act Now - Yes Link" data-gtm-product="glu6u" data-gtm-price="216"> Click here to add your additional 6-month supply, all 3 bonuses, and free shipping for just <s>$1182</s> $216.</a>
                    </div>
                    <a href="/bg/ud/glucogen-d-3" className="text-white-50 gg-small-text gg-link gtm-no-ud-btn" data-gtm-label="GlucoGen Upsell 6 - Act Now - No Link" data-gtm-product="glu6u" data-gtm-price="216">No Thanks, I’ll Miss This Unique Offer. I Understand That This Is A One-Time-Only Discount And Will No Longer Be Available Later.</a>
                    <div className="mt-4">
                        <picture>
                            <source srcSet={cardsImgWebp} type="image/webp" />
                            <img className="img-fluid gg-cards-max-height" src={cardsImg} loading="lazy" />
                        </picture>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default ActNow;